import styles from './Footer.module.css'

export default function Footer() {
  return (
    <>
      <div className={styles.footer}>
        Copyright © 2024 Fashion COM. All Right Reserved.
      </div>
    </>
  )
}
